import PropTypes from "prop-types"
import classNames from "classnames"
import { map } from "lodash"
import CompareSelect from "components/material/compare-select"
import { POSITIONS_DISPLAY_TYPES } from "helpers/comparison"
import PositionsTable from "./positions-table"
import { colorWithOpacity } from "helpers/colors"
import GroupRow from "./group-row"

function Positions({
  items,
  columns,
  data,
  positionsDisplayType,
  setPositionsDisplayType,
  setPositionsSorting,
  positionsSorting,
  positionsPagination,
  showPositionsPage,
  openSecurityProfile,
  openCompositeSecurity,
  fixedItemNumber,
  isActive,
}) {
  return <div className="compare-positions fixed">
    <div className={classNames({ "positions-group-panel": positionsDisplayType.id === "top10", "positions-select": positionsDisplayType.id === "all", "fixed-item-number": fixedItemNumber })}>
      <div className="positions-select-wrapper">
        <CompareSelect
          options={POSITIONS_DISPLAY_TYPES}
          selectedOption={positionsDisplayType}
          setSelected={setPositionsDisplayType}
        />
      </div>
      {positionsDisplayType.id === "top10"
        && map(columns, (column, i) =>
          <div className="group-column" key={i} style={{ backgroundColor: colorWithOpacity(column.color, 0.1) }}>
            {map(items[i], ({ label, value, chartWidth, description }, j) =>
              <GroupRow key={j} label={label} description={description} column={column} data={data} index={i} value={value} chartWidth={chartWidth} />,
            )}
          </div>,
        )}
    </div>
    {positionsDisplayType.id === "all"
      && <div className="positions-table">
        <PositionsTable
          items={items}
          columns={columns}
          data={data}
          setPositionsSorting={setPositionsSorting}
          positionsSorting={positionsSorting}
          positionsPagination={positionsPagination}
          showPositionsPage={showPositionsPage}
          openSecurityProfile={openSecurityProfile}
          openCompositeSecurity={openCompositeSecurity}
          fixedItemNumber={fixedItemNumber}
          isActive={isActive}
        />
      </div>}
  </div>
}

Positions.propTypes = {
  items: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  positionsDisplayType: PropTypes.object.isRequired,
  setPositionsDisplayType: PropTypes.func.isRequired,
  positionsSorting: PropTypes.object.isRequired,
  setPositionsSorting: PropTypes.func.isRequired,
  positionsPagination: PropTypes.object.isRequired,
  showPositionsPage: PropTypes.func.isRequired,
  openSecurityProfile: PropTypes.func.isRequired,
  openCompositeSecurity: PropTypes.func.isRequired,
  fixedItemNumber: PropTypes.bool,
  isActive: PropTypes.bool.isRequired,
}

export default Positions
